export default class NullDataError extends Error {
  public get name(): string {
    return "NullDataError";
  }
}
